export const parseLocalStorageBoolean = (value) => {
  // true/false were stored as booleans in local storage before
  // but some browsers don't support that and they would turn into strings
  // so booleans are now stored as 'on', 'off' strings
  return value === true || value === 'on';
};
